function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#2D2D2D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.55 1.943a4.606 4.606 0 100 9.212 4.606 4.606 0 000-9.212zM1 6.549a5.55 5.55 0 119.792 3.577l4.07 4.07a.472.472 0 01-.667.666l-4.07-4.07A5.55 5.55 0 011 6.55z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 6.5c0-.276.229-.5.511-.5H8.49C8.77 6 9 6.224 9 6.5s-.229.5-.511.5H4.51A.506.506 0 014 6.5z"
}));
function SvgAlejar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Alejar.svg";
export { SvgAlejar as ReactComponent };